exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4[data-v-80055d4e]{font-size:12px;font-weight:700}.card-footer[data-v-80055d4e]{border-top:0;background:#f7f9fc}.card[data-v-80055d4e]{border:0;border-radius:0;-webkit-box-shadow:1px 1px #ccd9e2;box-shadow:1px 1px #ccd9e2}", ""]);

// exports
